import {useEffect, useState} from "react";
import {requestAPI} from "../services";
import DataTable from 'react-data-table-component';
import {Alert, Button, Modal, Table} from "react-bootstrap";
import moment from 'moment';
import {toast} from "react-toastify";
import {BsFillEnvelopeFill} from "react-icons/bs";
import {FaPhoneAlt} from "react-icons/fa";

require('moment/locale/th.js');

function showStatus(status) {
    //console.log('=========',status);
    if (status.id == 1) {
        return <Alert className='mt-3' variant="success">{status.name}</Alert>;
    } else if (status.id == 2) {
        return <Alert className='mt-3' variant="danger">{status.name}</Alert>;
    } else {
        return <Alert className='mt-3' variant="warning">{status.name}</Alert>;
    }
}

function showDate(date) {
    date = moment(date).locale("th").format('ll');
    return date;
}

const conditionalRowStyles = [
    {
        when:row=>{
            let startDate = moment(row.booking.startDate).toDate();
            let now = new Date();
            now.setHours(0,0,0,0)
            return now > startDate;
        },
        style:{
            backgroundColor:'#c7c7c7'
        }
    }
];

const columns = [
    {
        name: '#',
        selector: row => row.number,
        sortable: true,
        width: '64px'
    },
    {
        name: 'สถานะ',
        selector: row => row.status.name,
        format: row => showStatus(row.status),
        width: '130px',
        sortable: true
    },
    {
        name: 'จองเมื่อ',
        selector: row => row.created_at,
        format: row => moment(row.created_at).format('ll H:mm น.'),
        sortable: true,
        width: '165px'
    },
    {
        name: 'กิจกรรม',
        selector: row => row.activity,
        format: row => {
            let startDate = moment(row.booking.startDate).toDate();
            let now = new Date();
            now.setHours(0,0,0,0);
            let state = '';
            if(now > startDate) state = 'เสร็จสิ้นไปแล้ว - ';
            // return <textarea rows='2' cols='40' readOnly style={{border: '0px'}} value={state + row.activity}></textarea>
            return <div className="text-wrap p-1">{state + row.activity}</div>
        },
        width: '375px',
    },
    {
        name: 'ห้องที่จอง',
        selector: row => row.room,
        // sortable: true,
        width: '195px'
    },
    {
        name: 'วันที่ใช้ห้อง',
        selector: row => row.date,
        sortable: true,
        format: row => showDate(row.date),
        width: '125px'
    },
    {
        name: 'เวลา',
        selector: row => row.time,
        width: '135px'
    },
    {
        name: 'ผู้จอง',
        selector: row => row.user,
        format: row => {
            let userArray = row.user.split('|');
            return <div onClick={e=>row.onClick(row.booking)}>
                <div>{userArray[0]}</div>
                <div>{userArray[1]}</div>
            </div>
        },
        sortable: true,
        width: '255px'
    },
    {
        name: 'ติดต่อ',
        selector: row => row.contact,
        width: '210px'
    },
    {
        name: 'รายละเอียด',
        selector: row => row.detail,
        // format: row => <textarea rows='2' cols='40' readOnly style={{border: '0px'}} value={row.detail}></textarea>
        format: row => <div className="text-wrap p-1" style={{width:320}}>{row.detail}</div>
        // width: '500px'
    },
];

const Admin = () => {
    const [booking, setBookings] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        reloadBooking()
    }, []);

    const [modal, setModal] = useState(false);

    function showTime(time) {
        time = time.replace(':00.000', '');
        return time;
    }

    function reloadBooking() {
        requestAPI('GET', '/bookings?_limit=-1&_sort=created_at:DESC').then(data => {
            setBookings(data);
            setLoaded(true);
        });
    }

    if (!loaded) return <Alert>Loading...</Alert>
    return (
        <div>
            <h4 className="mt-4 text-center"><b>การจัดการสถานะการจอง (Status)</b></h4>
            <DataTable
                fixedHeader
                onRowClicked={(row, event) => {
                    setModal(row.booking)
                }}
                columns={columns}
                data={booking.map((b, i) => {
                    return {
                        booking: b,
                        number: i + 1,
                        status: b.booking_status /*<div onClick={()=>setModal(b)} className="pt-3">{showStatus(b.booking_status)}</div>*/,
                        created_at: b.created_at,
                        activity: b.nameActivity /*<textarea rows='2' cols='40' readOnly style={{border:'0px'}}>{b.nameActivity}</textarea>*/,
                        room: b.booking_room.name,
                        date: b.startDate,
                        time: `${showTime(b.startTime)} - ${showTime(b.endTime)} น.`,
                        onClick:setModal,
                        user: `${b.booking_user?.firstname} ${b.booking_user?.lastname}|${b.booking_user?.faculty?.trim().replace(' มหาวิทยาลัยขอนแก่น', '')}` /*<div onClick={()=>setModal(b)}>
                            <div>{b.booking_user.firstname} {b.booking_user.lastname}</div>
                            <div>{b.booking_user.faculty.trim().replace(' มหาวิทยาลัยขอนแก่น','')}</div>
                        </div>*/,
                        contact: <div onClick={() => setModal(b)}>
                            <div><BsFillEnvelopeFill/> {b.booking_user?.email}</div>
                            <div><FaPhoneAlt size={10}/> {b.contact}</div>
                        </div>,
                        detail: b.description /*<textarea rows='2' cols='40' readOnly style={{border:'0px'}}>{b.description}</textarea>*/
                    }
                })}
                conditionalRowStyles={conditionalRowStyles}
            />

            {/*<Table responsive bordered hover className="mt-4">*/}
            {/*    <thead>*/}
            {/*    <tr className="text-center font-weight-bold">*/}
            {/*        <td>ลำดับ</td>*/}
            {/*        <td>สถานะ</td>*/}
            {/*        <td>กิจกรรม</td>*/}
            {/*        <td>ห้องที่จอง</td>*/}
            {/*        <td>วันที่ใช้ห้อง</td>*/}
            {/*        <td>เวลา</td>*/}
            {/*        <td>ผู้จอง</td>*/}
            {/*        <td>ติดต่อ</td>*/}
            {/*        <td>รายละเอียด</td>*/}
            {/*    </tr>*/}
            {/*    </thead>*/}
            {/*    <tbody>*/}
            {/*    {booking.map((b, i) => {*/}
            {/*        return (*/}
            {/*            <tr key={b.id} onClick={() => {*/}
            {/*                setModal(b)*/}
            {/*            }}*/}
            {/*            >*/}
            {/*                <td className="text-center">{i + 1}</td>*/}
            {/*                <td><div style={{whiteSpace:'nowrap'}}>{showStatus(b.booking_status)}</div></td>*/}
            {/*                <td><div style={{width:'200px'}}>{b.nameActivity}</div></td>*/}
            {/*                <td><div style={{whiteSpace:'nowrap'}}>{b.booking_room.name}</div></td>*/}
            {/*                <td><div style={{whiteSpace:'nowrap'}}>{showDate(b.startDate)}</div></td>*/}
            {/*                <td><div style={{whiteSpace:'nowrap'}}>{showTime(b.startTime)} - {showTime(b.endTime)} น.</div></td>*/}
            {/*                <td>*/}
            {/*                    <div style={{width:'150px'}}>{b.booking_user.firstname} {b.booking_user.lastname}</div>*/}
            {/*                    <div>({b.booking_user.faculty.trim()})</div>*/}
            {/*                </td>*/}
            {/*                <td>*/}
            {/*                    <div style={{whiteSpace:'nowrap'}}><BsFillEnvelopeFill/> {b.booking_user.email}</div>*/}
            {/*                    <div style={{whiteSpace:'nowrap'}}><FaPhoneAlt/> {b.contact}</div>*/}
            {/*                </td>*/}
            {/*                <td><div style={{width:'200px'}}>{b.description}</div></td>*/}
            {/*            </tr>*/}
            {/*        )*/}
            {/*    })}*/}
            {/*    </tbody>*/}
            {/*</Table>*/}

            {/*pop-up จัดการสถานะ admin*/}
            <Modal show={modal || false} onHide={() => {
                setModal(false)
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>การจัดการสถานะการจอง</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>กรุณาเลือกสถานะของกิจกรรม : {modal?.nameActivity}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" disabled={modal?.booking_status?.name == "Approve" ? true : false}
                            onClick={() => {
                                requestAPI('PUT', '/bookings/' + modal?.id, {"booking_status": "1"}).then(() => {
                                    setModal(false);
                                    toast.success("อัปเดตสถานะเสร็จสิ้น");
                                    reloadBooking();
                                })
                            }}>
                        Approve
                    </Button>
                    <Button variant="warning" disabled={modal?.booking_status?.name == "Pending" ? true : false}
                            onClick={() => {
                                requestAPI('PUT', '/bookings/' + modal?.id, {"booking_status": "3"}).then(() => {
                                    setModal(false);
                                    toast.success("อัปเดตสถานะเสร็จสิ้น");
                                    reloadBooking();
                                })
                            }}>
                        Pending
                    </Button>
                    <Button variant="danger" disabled={modal?.booking_status?.name == "Reject" ? true : false}
                            onClick={() => {
                                let msg = prompt('Message');
                                requestAPI('PUT', '/bookings/' + modal?.id, {
                                    "booking_status": "2",
                                    message: msg
                                }).then(() => {
                                    setModal(false);
                                    toast.success("อัปเดตสถานะเสร็จสิ้น");
                                    reloadBooking();
                                })
                            }}>
                        Reject
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setModal(false)
                    }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default Admin;
